import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classnames from 'classnames';
import React, { useContext } from 'react';
import { Loading, Toast, NoticeBar, Modal as ZaModal } from 'zarm';
import { fetchClick } from '@/components/Button';
import { dispatch, getState, getFormValue } from '@/store';
import { getHashParam } from '@/utils/tool';
import { getFetchBaseData, findModuleFromCurrPage } from '@/utils/utils';
import { ModuleContext } from '../BaseModule';
import { getLocalClick } from '../Button';
import './index.less';
const EventBtn = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    form,
    buttonText = '',
    events = {},
    className
  } = props;
  const context = useContext(ModuleContext) || {};
  const {
    buttonCode
  } = context;
  const cls = classnames({
    'base-button-render': true
  });
  const btnCls = classnames({
    btn: true
  }); // 获取投保人告知参数

  const setHolderNotice = data => {
    var _getState, _ref;

    const notice = (_getState = getState('notice')) === null || _getState === void 0 ? void 0 : _getState.holder;
    if (notice) return data;
    const {
      noticeDetailList = []
    } = notice || {};
    const nextNoticeDetailList = noticeDetailList.map((item = {}, index) => {
      // const noticeAnswer = buttonId;
      const noticeAnswer = buttonText.includes('是') ? 'unknown' : 'no';
      return _objectSpread(_objectSpread({}, item), {}, {
        noticeAnswer
      });
    });

    const noticeQuestion = _objectSpread(_objectSpread({}, notice), {}, {
      noticeDetailList: nextNoticeDetailList
    });

    const {
      holderNotice
    } = getState('healthNoticeInformation') || {};
    noticeQuestion.smartQuestionContent = (_ref = holderNotice || {}) === null || _ref === void 0 ? void 0 : _ref.smartQuestionContent;
    dispatch({
      'healthNoticeInformation.holderNotice': noticeQuestion
    });
    data.holder = _objectSpread(_objectSpread({}, data.holder), {}, {
      noticeQuestion
    });
    return data;
  }; // 投保人告知参数


  const setInsuredNotice = data => {
    var _getState2;

    const notice = (_getState2 = getState('notice')) === null || _getState2 === void 0 ? void 0 : _getState2.insured;
    if (notice) return null;
    const {
      noticeDetailList = []
    } = notice || {};
    const nextNoticeDetailList = noticeDetailList.map((item = {}, index) => {
      // const noticeAnswer = buttonId;
      const noticeAnswer = buttonText.includes('是') ? 'unknown' : 'no';
      return _objectSpread(_objectSpread({}, item), {}, {
        noticeAnswer
      });
    });

    const noticeQuestion = _objectSpread(_objectSpread({}, notice), {}, {
      noticeDetailList: nextNoticeDetailList
    });

    const {
      certNo
    } = getHashParam() || {};
    let currentInsured = 0;

    if (certNo) {
      // 找出是第几个被保人
      const insured = getFormValue('insured');
      currentInsured = insured.findIndex(i => i.certNo === certNo);
      data.extraInfo.currentInsuredFlag = certNo;
    }

    const {
      insuredNotice
    } = getState('healthNoticeInformation') || {};
    data.insuredList = data.insuredList || [];
    data.insuredList = data.insuredList.map((item = {}, index) => {
      var _index, _data$insuredList;

      noticeQuestion.smartQuestionContent = (_index = (insuredNotice || [])[index]) === null || _index === void 0 ? void 0 : _index.smartQuestionContent;
      dispatch({
        [`healthNoticeInformation.insuredNotice[${currentInsured}]`]: noticeQuestion
      }); // data?.insuredList?.length === 1说明是单被保人

      if (index === currentInsured || (data === null || data === void 0 ? void 0 : (_data$insuredList = data.insuredList) === null || _data$insuredList === void 0 ? void 0 : _data$insuredList.length) === 1) {
        return _objectSpread(_objectSpread({}, item), {}, {
          noticeQuestion: _objectSpread({}, noticeQuestion)
        });
      }

      return _objectSpread({}, item);
    });
    return data;
  }; // 获取下一步请求参数


  const getFetchDataWithNotice = () => {
    let data = getFetchBaseData();
    data.buttonCode = buttonCode;
    data = setHolderNotice(data);
    data = setInsuredNotice(data);
    return data;
  }; // 调用下一步请求


  const getNextStep = async _buttonCode => {
    const res = await form.validateFields(); // 对逐页阅读弹逻辑处理
    // 在逐页阅读弹出层会dispatch一个全局状态标识阅读按钮是否被点击，此处需要读取这个状态

    const hasSupervisionPopupModule = findModuleFromCurrPage('supervisionPopupModule');

    if (hasSupervisionPopupModule) {
      const supervisionClicked = getState('supervisionBtnClicked');
      const {
        clicked = false,
        supervisionTarget
      } = supervisionClicked;

      if (!clicked) {
        if (supervisionTarget) {
          // supervision 监督
          const target = getState(supervisionTarget); // 带有逐页阅读模块的页面后退进入其他页面时残余数据会走下面的方法 阻止调用下一步方法

          if (target) {
            target.setTab(1);
            const result = await target.show();
            if (!result) return Toast.show('请仔细阅读并勾选投保须知');
          }
        }
      }
    }

    Loading.show();
    const data = getFetchDataWithNotice();

    if (_buttonCode) {
      data.buttonCode = _buttonCode;
    } // data.noticeObjectType = noticeObjectType;


    Loading.hide();
    fetchClick(data, (resData = {}, next) => {
      const {
        pageAction
      } = resData;

      if (pageAction === 'continue') {
        return onClickLocal;
      }

      return next;
    });
  }; // 按钮配置事件处理


  const onClickLocal = getLocalClick(events, (eventData, next) => {
    if (eventData.type === 'behavior' && eventData.behavior === 'continue') {
      return getNextStep;
    }

    return next;
  });

  const handleClick = async () => {
    onClickLocal();
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: `${cls}`
  }, /*#__PURE__*/React.createElement("div", {
    className: `${btnCls} ${className} `,
    onClick: handleClick
  }, buttonText)));
});
export default EventBtn;